export const AGENTIC_PROMPT_SCOPES = {
  PARENTS: 'parents',
  CHILDREN: 'children',
  ALL: 'all',
}

// Mirrors Agentic::Prompt.statuses in irwin-api. Draft was removed; new prompts
// default to internal (not visible to end users until promoted to general).
export const AGENTIC_PROMPT_STATUSES = ['internal', 'general']

export const AGENTIC_PROMPT_DEFAULT_STATUS = 'internal'
